var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import moment from 'moment';
import ActionTypes from '../actionTypes';
import { GroupFilterValues } from './types';
import { dateToUrlDate } from '../../shared/functions';
var initialState = {
    selectedCriteria: null,
    selectedNewsGroup: GroupFilterValues.athlitikes,
    selectedDate: dateToUrlDate(moment()),
};
/**
 * Derives the next "appGlobalData" state from the previous one and the current action.
 */
var appGlobalDataReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case ActionTypes.UPDATE_GLOBAL_DATA_SELECTED_CRITERIA:
            return (__assign(__assign({}, state), { selectedCriteria: action.payload }));
        case ActionTypes.UPDATE_GLOBAL_DATA_SELECTED_NEWS_GROUP:
            return (__assign(__assign({}, state), { selectedNewsGroup: action.payload }));
        case ActionTypes.UPDATE_GLOBAL_DATA_SELECTED_DATE:
            return (__assign(__assign({}, state), { selectedDate: action.payload }));
        default:
            return state;
    }
};
export default appGlobalDataReducer;
